import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "section"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "text"
};
var _hoisted_4 = {
  class: "form"
};
var _hoisted_5 = {
  class: "block"
};
var _hoisted_6 = {
  class: "label"
};
var _hoisted_7 = {
  class: "value"
};
var _hoisted_8 = {
  class: "line"
};
var _hoisted_9 = {
  class: "item"
};
var _hoisted_10 = {
  class: "label"
};
var _hoisted_11 = {
  class: "value"
};
var _hoisted_12 = {
  class: "item"
};
var _hoisted_13 = {
  class: "label"
};
var _hoisted_14 = {
  class: "value"
};
var _hoisted_15 = {
  class: "line"
};
var _hoisted_16 = {
  class: "item"
};
var _hoisted_17 = {
  class: "label"
};
var _hoisted_18 = {
  class: "value"
};
var _hoisted_19 = {
  class: "item"
};
var _hoisted_20 = {
  class: "label"
};
var _hoisted_21 = {
  class: "value break-all"
};
var _hoisted_22 = {
  class: "block"
};
var _hoisted_23 = {
  class: "label"
};
var _hoisted_24 = {
  class: "value"
};
var _hoisted_25 = {
  class: "line"
};
var _hoisted_26 = {
  class: "item"
};
var _hoisted_27 = {
  class: "label"
};
var _hoisted_28 = {
  class: "value"
};
var _hoisted_29 = {
  class: "item"
};
var _hoisted_30 = {
  class: "label"
};
var _hoisted_31 = {
  class: "value"
};
var _hoisted_32 = {
  class: "section"
};
var _hoisted_33 = {
  class: "title"
};
var _hoisted_34 = {
  class: "text"
};
var _hoisted_35 = {
  class: "line"
};
var _hoisted_36 = {
  class: "item"
};
var _hoisted_37 = {
  class: "label"
};
var _hoisted_38 = {
  class: "value"
};
var _hoisted_39 = {
  class: "item"
};
var _hoisted_40 = {
  class: "label"
};
var _hoisted_41 = {
  class: "value"
};
var _hoisted_42 = {
  class: "block"
};
var _hoisted_43 = {
  class: "label"
};
var _hoisted_44 = {
  class: "value"
};
var _hoisted_45 = {
  key: 0,
  class: "footer"
};
import PagePopupLayout from "@/layouts/PagePopupLayout.vue";
import InvoiceStatusTag from "./InvoiceStatusTag.vue";
import { computed } from "vue";
import { watch } from "vue";
import { ref } from "vue";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { formatDateWithTZ } from "@/utils/format";
import { CountryCurrencySymbolEnum } from "@/constant/currency";
import { InvoiceStatusEnum } from "@/constant/invoice";
import { getInvoiceRecordDetail, cancelInvoice } from "@/api/invoice";
import { showToast } from "vant";
import { isWithinLastSec } from "@/utils/dateUtil";
import Common from "@/components/dialog/src/Common.vue";
import Input from "../base/Input.vue";
import { Notify } from "@/utils/notifyUtil";
import { INVOICE_CANCEL_ERROR } from "@/constant/responseCode";
import { priceUtil } from "@op/shared";
import { useI18n } from "vue-i18n";
import { getICDocTypeMap } from "@/constant/invoice";
export default {
  __name: 'InvoiceDetailPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    recordId: {
      type: String,
      required: true
    }
  },
  emits: ["update:show", "submit", "success"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var emit = __emit;
    var isShowRejectDialog = ref(false);
    var rejectReason = ref("");
    var props = __props;
    var data = ref({});
    var isShowBtn = computed(function () {
      if (!data.value.status || data.value.status === InvoiceStatusEnum.INVOICED) return false;
      if (data.value.status === InvoiceStatusEnum.UNDER_REVIEW) {
        return isWithinLastSec(data.value.order_info.order_time, 72 * 60 * 60);
      }
      return true;
    });
    function formatLocation(location) {
      if (!location) return "";
      var resArr = [location.address_line || "", [location.postcode, location.city].filter(function (item) {
        return !!item;
      }).join(" ") || "", location.state || "", location.country || ""];
      return resArr.filter(function (item) {
        return !!item;
      }).join(", ");
    }
    var showPopup = computed({
      get: function get() {
        return props.show;
      },
      set: function set(val) {
        emit("update:show", val);
      }
    });
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }
    function _fetchData() {
      _fetchData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              showLoading();
              _context.next = 3;
              return getInvoiceRecordDetail(props.recordId);
            case 3:
              res = _context.sent;
              hideLoading();
              if (res.isOK) {
                data.value = res.data;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }
    var submit = function submit() {
      if (data.value.status === InvoiceStatusEnum.UNDER_REVIEW) {
        rejectReason.value = "";
        isShowRejectDialog.value = true;
      } else {
        var _data$value$order_inf, _data$value$order_inf2;
        emit("submit", {
          orderId: (_data$value$order_inf = data.value.order_info) === null || _data$value$order_inf === void 0 ? void 0 : _data$value$order_inf.order_id,
          orderType: (_data$value$order_inf2 = data.value.order_info) === null || _data$value$order_inf2 === void 0 ? void 0 : _data$value$order_inf2.order_type,
          shopId: data.value.shop_id
        });
      }
    };
    function submitCancelInvoice() {
      return _submitCancelInvoice.apply(this, arguments);
    }
    function _submitCancelInvoice() {
      _submitCancelInvoice = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var params, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!rejectReason.value || !rejectReason.value.trim())) {
                _context2.next = 3;
                break;
              }
              showToast(t("pleaseInputTheReason"));
              return _context2.abrupt("return");
            case 3:
              params = {
                invoice_record_id: data.value.id,
                shop_id: data.value.shop_id,
                reason: rejectReason.value
              };
              showLoading();
              _context2.next = 7;
              return cancelInvoice(params);
            case 7:
              res = _context2.sent;
              if (res.isOK) {
                Notify.success(data.value.status === InvoiceStatusEnum.UNDER_REVIEW ? t("rejectionOfInvoicingApplicationSubmitted") : t("reInvoicingApplicationSubmitted"));
                isShowRejectDialog.value = false;
                fetchData();
                emit("success");
              } else if (res.code === INVOICE_CANCEL_ERROR) {
                Notify.error(t("invoiceStatusIsWrong"));
                hideLoading();
              } else {
                hideLoading();
              }
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _submitCancelInvoice.apply(this, arguments);
    }
    watch(showPopup, function (val) {
      if (val) {
        fetchData();
      } else {
        data.value = {};
      }
    });
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      var _component_Button = _resolveComponent("Button");
      return _openBlock(), _createBlock(PagePopupLayout, {
        ref: "pagePopupRef",
        show: showPopup.value,
        "onUpdate:show": _cache[2] || (_cache[2] = function ($event) {
          return showPopup.value = $event;
        }),
        title: _ctx.$t('eInvoiceDetails'),
        class: "invoice-detail",
        "show-footer": ""
      }, {
        footer: _withCtx(function () {
          return [isShowBtn.value ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createVNode(_component_Button, {
            type: "border",
            class: "btn",
            onClick: submit
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(data.value.status === _unref(InvoiceStatusEnum).VOIDED ? _ctx.$t("reInvoicing") : _ctx.$t("rejectInvoicing")), 1)];
            }),
            _: 1
          })])) : _createCommentVNode("", true)];
        }),
        default: _withCtx(function () {
          var _data$value$invoice_d, _data$value$invoice_d2, _data$value$invoice_d3, _data$value$invoice_d4, _data$value$invoice_d5, _data$value$invoice_d6, _data$value$invoice_d7, _data$value$invoice_d8, _data$value$order_inf3, _data$value$order_inf4, _data$value$order_inf5;
          return [_createVNode(_component_Gap, {
            h: 0.1
          }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("taxpayerInformation")), 1), _createVNode(InvoiceStatusTag, {
            value: data.value.status
          }, null, 8, ["value"])]), _cache[3] || (_cache[3] = _createElementVNode("div", {
            class: "division"
          }, null, -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("name")), 1), _createElementVNode("div", _hoisted_7, _toDisplayString((_data$value$invoice_d = data.value.invoice_data) === null || _data$value$invoice_d === void 0 || (_data$value$invoice_d = _data$value$invoice_d.buyer) === null || _data$value$invoice_d === void 0 ? void 0 : _data$value$invoice_d.name), 1)]), _createVNode(_component_Gap, {
            h: 0.14
          }), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("tinNo")), 1), _createElementVNode("div", _hoisted_11, _toDisplayString((_data$value$invoice_d2 = data.value.invoice_data) === null || _data$value$invoice_d2 === void 0 || (_data$value$invoice_d2 = _data$value$invoice_d2.buyer) === null || _data$value$invoice_d2 === void 0 ? void 0 : _data$value$invoice_d2.tin), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_unref(getICDocTypeMap)()[(_data$value$invoice_d3 = data.value.invoice_data) === null || _data$value$invoice_d3 === void 0 || (_data$value$invoice_d3 = _data$value$invoice_d3.buyer) === null || _data$value$invoice_d3 === void 0 ? void 0 : _data$value$invoice_d3.id_doc_type]), 1), _createElementVNode("div", _hoisted_14, _toDisplayString((_data$value$invoice_d4 = data.value.invoice_data) === null || _data$value$invoice_d4 === void 0 || (_data$value$invoice_d4 = _data$value$invoice_d4.buyer) === null || _data$value$invoice_d4 === void 0 ? void 0 : _data$value$invoice_d4.id_doc_no), 1)])]), _createVNode(_component_Gap, {
            h: 0.14
          }), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("sstRegistrationNo")), 1), _createElementVNode("div", _hoisted_18, _toDisplayString((_data$value$invoice_d5 = data.value.invoice_data) === null || _data$value$invoice_d5 === void 0 || (_data$value$invoice_d5 = _data$value$invoice_d5.buyer) === null || _data$value$invoice_d5 === void 0 || (_data$value$invoice_d5 = _data$value$invoice_d5.trn_list) === null || _data$value$invoice_d5 === void 0 || (_data$value$invoice_d5 = _data$value$invoice_d5.find(function (t) {
            return t.tax_type === "sst";
          })) === null || _data$value$invoice_d5 === void 0 ? void 0 : _data$value$invoice_d5.number), 1)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("email")), 1), _createElementVNode("div", _hoisted_21, _toDisplayString((_data$value$invoice_d6 = data.value.invoice_data) === null || _data$value$invoice_d6 === void 0 || (_data$value$invoice_d6 = _data$value$invoice_d6.buyer) === null || _data$value$invoice_d6 === void 0 ? void 0 : _data$value$invoice_d6.email), 1)])]), _createVNode(_component_Gap, {
            h: 0.14
          }), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("address")), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(formatLocation((_data$value$invoice_d7 = data.value.invoice_data) === null || _data$value$invoice_d7 === void 0 || (_data$value$invoice_d7 = _data$value$invoice_d7.buyer) === null || _data$value$invoice_d7 === void 0 ? void 0 : _data$value$invoice_d7.address)), 1)]), _createVNode(_component_Gap, {
            h: 0.14
          }), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("contactNo")), 1), _createElementVNode("div", _hoisted_28, _toDisplayString((_data$value$invoice_d8 = data.value.invoice_data) === null || _data$value$invoice_d8 === void 0 || (_data$value$invoice_d8 = _data$value$invoice_d8.buyer) === null || _data$value$invoice_d8 === void 0 ? void 0 : _data$value$invoice_d8.contact_number), 1)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("applicationTime")), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(formatDateWithTZ)(data.value.create_at)), 1)])])])]), _createVNode(_component_Gap, {
            h: 0.1
          }), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t("orderInfo")), 1)]), _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "division"
          }, null, -1)), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("orderID")), 1), _createElementVNode("div", _hoisted_38, _toDisplayString((_data$value$order_inf3 = data.value.order_info) === null || _data$value$order_inf3 === void 0 ? void 0 : _data$value$order_inf3.order_id), 1)]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("amount")), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice((_data$value$order_inf4 = data.value.order_info) === null || _data$value$order_inf4 === void 0 ? void 0 : _data$value$order_inf4.order_amount, _unref(CountryCurrencySymbolEnum)[data.value.country], true)), 1)])]), _createVNode(_component_Gap, {
            h: 0.14
          }), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("orderTime")), 1), _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(formatDateWithTZ)((_data$value$order_inf5 = data.value.order_info) === null || _data$value$order_inf5 === void 0 ? void 0 : _data$value$order_inf5.order_time)), 1)])]), _createVNode(Common, {
            visible: isShowRejectDialog.value,
            "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
              return isShowRejectDialog.value = $event;
            }),
            title: _ctx.$t('rejectReason'),
            "without-cancel": true,
            "ok-text": _ctx.$t('submit'),
            "on-ok": submitCancelInvoice
          }, {
            content: _withCtx(function () {
              return [_createElementVNode("div", null, [_createVNode(Input, {
                modelValue: rejectReason.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return rejectReason.value = $event;
                }),
                type: "textarea",
                rows: 5
              }, null, 8, ["modelValue"])])];
            }),
            _: 1
          }, 8, ["visible", "title", "ok-text"])];
        }),
        _: 1
      }, 8, ["show", "title"]);
    };
  }
};